import script from "./userCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./userCheck.vue?vue&type=script&setup=true&lang=js"

import "./userCheck.vue?vue&type=style&index=0&id=32913a14&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32913a14"]])

export default __exports__